var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoNextRetreatIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.2431 10.6611C40.5896 10.6611 40.0761 11.1748 40.0761 11.8286V33.7772C40.0761 34.431 40.5896 34.9446 41.2431 34.9446H43.5305C44.184 34.9446 44.6975 34.431 44.6975 33.7772V11.8286C44.6975 11.1748 44.184 10.6611 43.5305 10.6611H41.2431Z",
    fill: "#62AAEC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.3232 11.1281C21.8709 8.41954 38.8625 18.3198 38.8625 22.009C38.8625 28.4535 22.5244 37.0461 19.817 34.6178C15.8492 31.1153 14.0753 14.3503 18.3232 11.1281Z",
    fill: "#62AAEC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9715 22.0092C23.9715 18.2733 6.97993 8.41978 3.43225 11.1283C-0.768965 14.3506 0.958198 31.1623 4.92601 34.618C7.68013 37.0463 23.9715 28.4537 23.9715 22.0092Z",
    fill: "#005BAE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9715 22.009C23.9715 20.3278 20.4705 17.3858 16.3159 14.9107C15.3356 19.2537 15.8958 25.885 17.3896 30.3681C21.0307 27.8464 23.9715 24.7175 23.9715 22.009Z",
    fill: "#003DA1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoNextRetreatIcon);
export default __webpack_public_path__ + "static/media/logo-next-retreat-icon.87eae2cee55db204cca82cfcf6a4976a.svg";
export { ForwardRef as ReactComponent };